import ListenerGroup from '../../../util/ListenerGroup';
import { ContentNavItem, NavItem } from './NavItem';
import NavItems from './NavItems';
import navUtil from './navUtil';

class NavState {

  listenerGroup = new ListenerGroup('NavState');
  currentContentNavItem: ContentNavItem = NavItems.contentNavItems[0];
  secondaryNavItems: string[] = [];
  modalNavItem: undefined | ContentNavItem = undefined;

  constructor() {
    this._setCurrentLocation();
    window.addEventListener("hashchange", this.onHashChange);
  }

  onHashChange = () => {
    this._setCurrentLocation();
    this._notifyListeners();
  }

  _setCurrentLocation = () => {
    // The follow will switch from a query nav scheme to a hash nav scheme. For
    // example http://localhost:3000?view=forge-migration/FAD-1 becomes http://localhost:3000/#forge-migration/FAD-1.
    navUtil.possiblyRedirectToHashUrl();
    // debugger;
    const navOptions = navUtil.getNavOptions();
    if (navOptions.primaryItem !== undefined) {
      for (const navItem of NavItems.getAllNavItems()) {
        const contentNavItem = navUtil.navItemAsContentNavItem(navItem);
        if (contentNavItem) {
          // const atThisNavItem = (navOptions.primaryItem === '' && navItem.key === '') ||
          //   (navItem.key !== '' && (navOptions.primaryItem.indexOf(`#${navItem.key}`) === 0 || navOptions.primaryItem.indexOf(`${navItem.key}`) === 0));
          const atThisNavItem = (navOptions.primaryItem === '' && navItem.key === '') ||
            (navItem.key !== '' && (navOptions.primaryItem === `#${navItem.key}`));
          if (atThisNavItem) {
            this.currentContentNavItem = contentNavItem;
            this.secondaryNavItems = navOptions.secondaryItems || [];
            break;
          }
        }
      }
    }
  }

  getCurrentContentNavItem = () => {
    return this.currentContentNavItem;
  }

  getSecondaryNavItems = (): string[] => {
    return this.secondaryNavItems;
  }

  getModalNavItem = (): undefined | ContentNavItem => {
    return this.modalNavItem;
  }

  getSecondaryNavItemValueByKey = (key: string): undefined | string => {
    for (const secondaryNavItem of this.secondaryNavItems) {
      const prefix = `${key}=`;
      if (secondaryNavItem.indexOf(prefix) === 0) {
        const value = secondaryNavItem.substring(prefix.length);
        return value;
      }
    }
    return undefined;
  }

  removeSecondaryNavItemValueByKey = (key: string): void => {
    let newHash = '#' + this.currentContentNavItem.key;
    const newSecondaryNavItems: string[] = [];
    for (const secondaryNavItem of this.secondaryNavItems) {
      const prefix = `${key}=`;
      if (secondaryNavItem.indexOf(prefix) === 0) {
        // skip
      } else {
        newSecondaryNavItems.push(secondaryNavItem);
        newHash += '/' + secondaryNavItem;
      }
    }
    this.secondaryNavItems = newSecondaryNavItems;
    window.location.hash = newHash;
  }

  isSelected = (navItem: NavItem) => {
    return navItem.key === this.currentContentNavItem.key;
  }

  setLocation = (navItem: ContentNavItem) => {
    this.currentContentNavItem = navItem;
    window.location.hash = navItem.key;
    if (window.location.pathname) {
      window.location.pathname = '';
    }
    this._notifyListeners();
  }

  setModalNavItem = (navItem: undefined | ContentNavItem) => {
    this.modalNavItem = navItem;
    this._notifyListeners();
  }

  registerListener = (listener: any) => {
    this.listenerGroup.registerListener(listener);
  };

  unregisterListener = (listener: any) => {
    this.listenerGroup.unregisterListener(listener);
  };

  _notifyListeners = () => {
    this.listenerGroup.notifyListeners(this.currentContentNavItem);
  };

}

const navState = new NavState();
export default navState;
